import React          from 'react'
import { withRouter } from 'react-router'
import { Alert      } from 'react-bootstrap'

import { isValidEmail                   } from 'alto-utils/lib/utils'
import { Panel, HorizontalForm          } from 'alto-react-components/lib/components'
import { withAuthMessage                } from 'alto-react-base-auth/lib/utils'
import { NotFoundError, BadRequestError } from 'lib/errors'

import { withAuthContext                } from './context'

class ResendActivationEmail extends React.Component
  constructor: (props) ->
    super(props)

    @state = { email: '' }

  render: ->
    <Panel className="auth-panel" id="resend-activation-email-panel"
           header="Znovuzaslání aktivačního emailu" bsStyle="info">
      {@alert()}
      {@form()}
    </Panel>

  alert: ->
    <Alert id="resend-activation-email-alert" bsStyle="danger">{@state.error}</Alert> if @state.error

  form: ->
    <HorizontalForm>
      <HorizontalForm.Control id='email' type='email'
       label='Email' value={@state.email}
       onChange={(value) => @setState(email: value)}
       onKeyPress={(e) => @submit() if e.key == 'Enter'} />

      <HorizontalForm.Button id='resend-activation-email-submit' caption='Potvrdit' bsStyle="primary"
                             onClick={@submit} disabled={!isValidEmail(@state.email)} />
    </HorizontalForm>

  submit: =>
    @context.auth.resendActivationEmail(@state.email)
      .then (response) =>
        @props.history.push(withAuthMessage('/', 'activation_email_resending_successful', 'success'))

        null # otherwise runaway promise
      .catch NotFoundError, (error) =>
        @setState(error: 'Uživatel se zadanou emailovou adresou nebyl nalezen.')
      .catch BadRequestError, (error) =>
        @setState(error: error.data.detail)

export default withRouter(withAuthContext(ResendActivationEmail))
